var ALIGN_LEFT        = 'left',
    ALIGN_CENTER      = 'center',
    ALIGN_RIGHT       = 'right',
    ALIGN_TOP         = 'top',
    ALIGN_BOTTOM      = 'top',
    CLASS_TOP_STATE   = 'sc-menu__top',
    CLASS_LEFT_STATE  = 'sc-menu__left',
    CLASS_RIGHT_STATE = 'sc-menu__right',
    ORIENTATION_B     = 'bottom',
    ORIENTATION_T     = 'top',
    ORIENTATION_L     = 'left',
    ORIENTATION_R     = 'right',
    ARROW_SIZE        = 9;

class PositionManager {
    constructor(menu) {
        this._menu = menu;
    }

    /**
     * Меню надо переместить в div, относительно которого меню будет позиционироваться.
     *
     * По умолчанию, это #mainContainer
     */
    fixParent() {

        var menu = this._menu, el = menu.getEl(), targetEl = menu.getTargetEl();

        if (el.parentNode !== targetEl) {
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            }

            targetEl.appendChild(el);
        }
    }

    fix() {
        var orientation = this._menu.options.orientation;
        switch (orientation) {
            case ORIENTATION_L:
            case ORIENTATION_R:
                return this.fixH(orientation);
            default:
                return this.fixV(orientation);
        }
    }

    /**
     * Меняет координаты меню на оптимальные для пользователя
     */
    fixV(defaultOrientation) {

        var menu = this._menu, options = menu.options, el = menu.getEl(), triggerEl = menu.getTriggerEl(),
            arrowEl = menu.getArrowEl(), targetEl = menu.getTargetEl(), elStyle = el.style,
            triggerElStyle = triggerEl.style, margin = +options.margin, vmargin = +options.vmargin,
            haveArrow = options.noarrow !== "1", orientation = defaultOrientation, windowMargin = 30, arrowSize = 0,
            elRect, triggerElRect, targetElRect, left, top;

        if (haveArrow) {
            arrowSize = ARROW_SIZE;
        }

        triggerElRect = triggerEl.getBoundingClientRect();
        targetElRect = targetEl.getBoundingClientRect();

        elStyle.left = triggerElRect.left - targetElRect.left + 'px';
        elStyle.top = triggerElRect.top - targetElRect.top + 'px';
        elStyle.margin = 0;

        elRect = el.getBoundingClientRect();

        switch (options.align) {
            case ALIGN_LEFT:
                left = margin;
                break;
            case ALIGN_RIGHT:
                left = triggerElRect.width - elRect.width - margin;
                break;
            case ALIGN_CENTER:
            default:
                left = ((triggerElRect.width - elRect.width) / 2) + margin;
                break;
        }

        var bottomPlace = window.innerHeight - (triggerElRect.top + triggerElRect.height + vmargin),
            topPlace = triggerElRect.top;

        bottomPlace -= arrowSize;
        topPlace -= arrowSize;

        if (orientation === ORIENTATION_B) {
            if ((bottomPlace < elRect.height) && (topPlace > bottomPlace)) {
                // места для меню больше вверху, чем внизу
                top = -elRect.height - vmargin - arrowSize;
                el.classList.add(CLASS_TOP_STATE);
                orientation = ORIENTATION_T;
            } else {
                top = triggerElRect.height + vmargin + arrowSize;
                el.classList.remove(CLASS_TOP_STATE);
            }
        } else {
            if ((topPlace < elRect.height) && (bottomPlace > topPlace)) {
                // места для меню больше внизу, чем вверху
                top = triggerElRect.height + vmargin + arrowSize;
                el.classList.remove(CLASS_TOP_STATE);
                orientation = ORIENTATION_B;
            } else {
                top = -elRect.height - vmargin - arrowSize;
                el.classList.add(CLASS_TOP_STATE);
            }
        }

        if (elRect.left + left < 0) {
            left = windowMargin - elRect.left;
        }

        if (elRect.left + left + elRect.width > window.innerWidth) {
            left = window.innerWidth - elRect.width - elRect.left - windowMargin;
        }

        elStyle.left = (left + triggerElRect.left - targetElRect.left) + 'px';
        elStyle.top = (top + triggerElRect.top - targetElRect.top) + 'px';

        if (arrowEl) {
            arrowEl.style.left = (triggerElRect.width / 2 - left) + 'px';
        }

        return orientation;

    }

    /**
     * Меняет координаты меню на оптимальные для пользователя
     */
    fixH(defaultOrientation) {

        var menu = this._menu, options = menu.options, el = menu.getEl(), triggerEl = menu.getTriggerEl(),
            arrowEl = menu.getArrowEl(), targetEl = menu.getTargetEl(), elStyle = el.style,
            triggerElStyle = triggerEl.style, margin = +options.margin, vmargin = +options.vmargin, windowMargin = 30,
            orientation = defaultOrientation, haveArrow = menu.options.noarrow !== "1", elRect, triggerElRect,
            targetElRect, top, left1;

        if (haveArrow) {
            margin += ARROW_SIZE;
        }

        if (defaultOrientation === ORIENTATION_R) {
            el.classList.remove(CLASS_LEFT_STATE);
            el.classList.add(CLASS_RIGHT_STATE);
        } else {
            el.classList.remove(CLASS_RIGHT_STATE);
            el.classList.add(CLASS_LEFT_STATE);
        }

        triggerElRect = triggerEl.getBoundingClientRect();
        targetElRect = targetEl.getBoundingClientRect();

        elStyle.left = triggerElRect.left - targetElRect.left + 'px';
        elStyle.top = triggerElRect.top - targetElRect.top + 'px';
        elStyle.margin = 0;

        elRect = el.getBoundingClientRect();

        switch (options.align) {
            case ALIGN_BOTTOM:
                top = vmargin;
                break;
            case ALIGN_TOP:
                top = triggerElRect.height - elRect.height - vmargin;
                break;
            default:
                top = ((triggerElRect.height - elRect.height) / 2) + vmargin;
                break;
        }

        var rightPlace = window.innerWidth - (triggerElRect.left + triggerElRect.width + margin),
            leftPlace = triggerElRect.left;

        function toLeft() {
            // места для меню больше слева, чем справа
            left1 = -elRect.width - margin;
            el.classList.remove(CLASS_RIGHT_STATE);
            el.classList.add(CLASS_LEFT_STATE);
        }

        function toRight() {
            left1 = triggerElRect.width + margin;
            el.classList.remove(CLASS_LEFT_STATE);
            el.classList.add(CLASS_RIGHT_STATE);
        }

        switch (orientation) {
            case ORIENTATION_R:
                if ((rightPlace < elRect.width) && (leftPlace > rightPlace)) {
                    // места для меню больше слева, чем справа
                    orientation = ORIENTATION_L;
                }
                break;
            case ORIENTATION_L:
                if ((leftPlace < elRect.width) && (leftPlace < rightPlace)) {
                    // места для меню больше справа
                    orientation = ORIENTATION_R;
                }
        }

        if (orientation === ORIENTATION_R) {
            toRight();
        } else {
            toLeft();
        }

        if (elRect.top + top < 0) {
            top = windowMargin - elRect.top;
        }

        if (elRect.top + top + elRect.height > window.innerHeight) {
            top = window.innerHeight - elRect.height - elRect.top - windowMargin;
        }

        elStyle.top = (top + triggerElRect.top - targetElRect.top) + 'px';
        elStyle.left = (left1 + triggerElRect.left - targetElRect.left) + 'px';

        if (haveArrow) {
            arrowEl.style.top = (triggerElRect.height / 2 - top) + 'px';
        }

        return orientation;
    }

    destroy() {
        OK.util.clean(this);
    }
}

PositionManager.ALIGN_LEFT = ALIGN_LEFT;
PositionManager.ALIGN_CENTER = ALIGN_CENTER;
PositionManager.ALIGN_RIGHT = ALIGN_RIGHT;

PositionManager.ORIENTATION_B = ORIENTATION_B;
PositionManager.ORIENTATION_T = ORIENTATION_T;
PositionManager.ORIENTATION_L = ORIENTATION_L;
PositionManager.ORIENTATION_R = ORIENTATION_R;

export default PositionManager;


export { ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT, ORIENTATION_B, ORIENTATION_T, ORIENTATION_L, ORIENTATION_R };
